module.exports = __webpack_public_path__ + "static/media/inventory-clearance-event-logo.829b8d7d.svg";